import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { BILLING_PATH } from 'routes';
const TrialUpgradeModal = ({ isShown, closeModal }) => {
  return (
    <Modal isOpen={isShown} className="upgrade-trial-modal">
      <ModalHeader toggle={closeModal}>
        <div className="upgrade-trial-modal__heading">
          <h3 className="center">Upgrade to create multiple projects</h3>
          <p className="center description">
            You can have only one domain while on a Free plan. You can either
            delete or archive a domain, or <a href={BILLING_PATH}>upgrade</a>{' '}
            your account
          </p>
        </div>
        <hr />
      </ModalHeader>
      <ModalBody>
        <div className="upgrade-trial-modal__body">
          <p className="center description also">Also you will get</p>
          <div className="features">
            <div className="feature-container">
              <span className="feature-icon">+</span>
              <span className="feature-text">Unlimited links</span>
            </div>
            <div className="feature-container">
              <span className="feature-icon">+</span>
              <span className="feature-text">Custom domain URL</span>
            </div>
            <div className="feature-container">
              <span className="feature-icon">+</span>
              <span className="feature-text">Advanced customization</span>
            </div>
            <div className="feature-container">
              <span className="feature-icon">+</span>
              <span className="feature-text">Remove instaLinks branding</span>
            </div>
          </div>
        </div>
        <hr />
      </ModalBody>
      <ModalFooter>
        <div className="upgrade-trial-modal__controls">
          <NavLink to={BILLING_PATH} className="btn btn-blue big upgrade">
            Upgrade now
          </NavLink>
          <Button className="btn btn-blue big cancel" onClick={closeModal}>
            Cancel
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TrialUpgradeModal);



// WEBPACK FOOTER //
// ./src/components/TrialUpgradeModal/index.js